var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Login as this User")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('a',{staticClass:"button is-info is-fullwidth",on:{"click":function($event){$event.preventDefault();_vm.loginAsThisUser(_vm.user)}}},[_vm._v("Login As "+_vm._s(_vm.user.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f4a8996","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/User/Inputs/UserLogin.vue
// module id = null
// module chunks = 